import {
  si
} from "./chunk.S3625EU6.js";

// node_modules/lit-html/directive-helpers.js
var { I: et } = si;
var st = (o) => null === o || "object" != typeof o && "function" != typeof o;
var nt = (o, t) => void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t;
var ot = (o) => null != o?._$litType$?.h;
var rt = (o) => void 0 === o.strings;
var ht = {};
var dt = (o, t = ht) => o._$AH = t;

export {
  st,
  nt,
  ot,
  rt,
  dt
};
/*! Bundled license information:

lit-html/directive-helpers.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
